import React, {memo, useCallback, useContext, useMemo, useRef, useState} from 'react';
import Icon from 'deprecated-shared-ui/templates/icon';
import Loader from 'deprecated-shared-ui/templates/loader/default';import {Constants} from '../view-constants';
import {articleOverviewStaticContext} from '../ArticleOverviewStatic.jsx';
import useEffectOnUpdate from '../helper/hooks-helper';

export default function AlpiHeroPicture({
                                            url,
                                            image,
                                            inView,
                                            heroPictureOnClick,
                                            onLoad,
                                            heroPictureOnAuxClick,
                                            heroPictureOnContextMenu,
                                        }) {
    const {imagePath} = useContext(articleOverviewStaticContext);

    const sources = useMemo(() => {
        if (!image?.src) return [];
        
        const responsiveSizes = [
            { size: '477x668', media: '(min-width: 1600px)' },
            { size: '397x556', media: '(min-width: 1280px)' },
            { size: '317x444', media: '(min-width: 992px)' },
            { size: '245x343', media: '(min-width: 768px)' },
            { size: '253x354', media: '(min-width: 480px)' },
            { size: '238x333', media: '(max-width: 479px)' }
        ];
        
        return responsiveSizes.map(({ size, media }) => ({
            srcSet: {
                src: `${size}/${image.src} 1x`,
                src2x: `${size}/2x/${image.src} 2x`
            },
            media
        }));
    }, [image])

    const src = imagePath + '477x668/' + image?.src


    const [loaded, setLoaded] = useState(false);
    const [showFallback, setShowFallback] = useState(false);
    const linkTagRef = useRef();

    const onAuxClick = (e) => {
        heroPictureOnAuxClick(e, linkTagRef.current);
    };
    const onContextMenu = (e) => {
        heroPictureOnContextMenu(e, linkTagRef.current);
    };

    const handleImageLoad = () => {
        onLoad();
        setLoaded(true);
        setShowFallback(false);
    };

    const handleImageError = () => {
        setShowFallback(true);
        onLoad();
    };

    return (
        <div className="alpi__image" data-testid="alpi__image" onClick={heroPictureOnClick} onContextMenu={onContextMenu} onAuxClick={onAuxClick}>
            {(!inView && !loaded) ? <Loading/> : renderImage()}
        </div>
    );

    function renderImage() {
        const showLoader = !loaded && !showFallback;

        // Always render the image, but control visibility with opacity/visibility
        const imageStyle = loaded || showFallback ? {} : {opacity: 0, visibility: 'hidden'};

        return (
            <>
                {showLoader && <Loading/>}
                {/* data-product-link: the tile draws the focus ring for this link (the anchor itself
                    is a zero-size flex item inside the aspect-ratio box and is clipped by the slider) */}
                <a ref={linkTagRef} className="alpi__image-link" href={url} data-product-link>
                    {showFallback && <FallbackImage altText={image.alt}/>}
                    {!showFallback && (
                        <picture className={'alpi__picture-wrapper'} style={imageStyle}>
                            {sources.map((source, index) => {
                                return (
                                    <source
                                        key={index}
                                        media={source.media}
                                        srcSet={imagePath + source.srcSet.src + ', ' + imagePath + source.srcSet.src2x}
                                    />
                                );
                            })}
                            <img
                                loading={'lazy'}
                                className="responsive-image__img-tag"
                                onLoad={handleImageLoad}
                                onError={handleImageError}
                                src={src}
                                alt={image.alt}
                                height={Constants.DEFAULT_IMAGE_HEIGHT}
                                width={Constants.DEFAULT_IMAGE_WIDTH}
                            />
                        </picture>
                    )}
                </a>
            </>
        );
    }
}

const Loading = () => {
    return (
        <div className="alpi__image-loader-wrapper">
            <Loader className="alpi__image-loader"/>
        </div>
    );
};

const FallbackImage = memo(function FallbackImage({altText}) {
    const placeHolderImage = {
        fallbackSrc: Constants.PLACEHOLDER_IMAGE_XLARGE_BASE64,
        sources: [
            {
                media: Constants.MEDIA_QUERY_SMALL,
                srcSet: `${Constants.PLACEHOLDER_IMAGE_SMALL_BASE64} 1x, ${Constants.PLACEHOLDER_IMAGE_SMALL_RETINA_BASE64} 2x`,
            },
            {
                media: Constants.MEDIA_QUERY_XLARGE,
                srcSet: `${Constants.PLACEHOLDER_IMAGE_XLARGE_BASE64} 1x, ${Constants.PLACEHOLDER_IMAGE_XLARGE_RETINA_BASE64} 2x`,
            },
        ],
    };

    return (
        <picture className={'alpi__picture-wrapper'}>
            <div className="alpi__fallback-image-content-wrapper">
                <Icon name="placeholder" className="placeholder-icon"/>
            </div>
            {placeHolderImage.sources.map((source) => {
                return <source media={source.media} srcSet={source.srcSet}/>;
            })}
            <img
                className="responsive-image__img-tag"
                src={placeHolderImage.fallbackSrc}
                alt={altText}
                height={Constants.DEFAULT_IMAGE_HEIGHT}
                width={Constants.DEFAULT_IMAGE_WIDTH}
            />
        </picture>
    );
});
